import qs from "qs"
import request from "../utils/request"

// 按职务将人员进行归类统计
export function getCountByJob(param) {
	return request({
		method: "POST",
		url: "/org/person/countByJob",
		data: param
	})
}
// 按报销类别将人员进行归类统计
export function getCountByPersonType(param) {
	return request({
		method: "GET",
		url: "/org/person/countByPersonType?flag=" + param.flag
	})
}

//组织中心部门人员
export function getPerList(b) {
	return request({
		method: "GET",
		url: "/org/getDeptHr?orgId=" + b
	})
}

export function searchZw(param) {
	return request({
		method: "POST",
		url: "/org/classify/selDutys",
		data: param
	})
}

export function searchDeptAndPer(param) {
	return request({
		method: "POST",
		url: "/org/classify/selDepartAndPersons",
		data: param
	})
}

export function getClassifyList(b) {
	return request({
		method: "GET",
		url: "/org/classify/selOrgclassifyList"
	})
}

export function getAllDeptPersons(param) {
	return request({
		method: "GET",
		url: "/org/person/getAllDeptPersons?orgId=" + param.orgId + "&classifyCode=" + param.classifyCode + "&isAdministrative=" + param.isAdministrative + "&flag=" + param.flag
	})
}

export function getSearchList(param) {
	return request({
		method: "GET",
		url: "/person/getPerson?personName=" + param.str + "&pageNo=" + param.pageNo + "&pageSize=30"
	})
}
